import useShallowSelector from "./useShallowSelector";

const useMe = () => {
    return useShallowSelector(state => state.me);
};

export default useMe;
